export interface UserConstructorData {
  id: number
  firstName: string
  lastName: string
  profileImage: Nullable<string>
}

// A basic user entity. If the object contains other fields, use an entity type that extends this one
// such as Approver or Requester.
export class User {
  id: number
  firstName: string
  lastName: string
  profileImage: Nullable<string>

  constructor(data: UserConstructorData) {
    this.id = data.id
    this.firstName = data.firstName
    this.lastName = data.lastName
    this.profileImage = data.profileImage
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`
  }
}
